import styled, { css } from 'styled-components'

import * as colors from '../../constants/colors'
import * as copy from '../copy'
import * as image from '../image'

export const Avatar = styled(image.Pastille)<{ hasAvatar: boolean; isHoverEnabled?: boolean }>`
  height: 110px;
  overflow: hidden;
  position: relative;
  width: 110px;

  img {
    height: 100%;
    max-height: none;
    max-width: none;
    object-fit: cover;
    width: 100%;
  }

  ${({ hasAvatar, isHoverEnabled = false }) => {
    if (isHoverEnabled) {
      if (!hasAvatar) {
        return css`
          ${HoverInfo} {
            display: flex;
          }
        `
      } else {
        return css`
          ${HoverInfo} {
            display: none;
          }

          &:hover ${HoverInfo} {
            display: flex;
          }
        `
      }
    }
  }};
`

export const HoverInfo = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4); // TODO: Replace w/ OVERLAY token once available.
  bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  max-height: none;
  max-width: none;
  position: absolute;
  right: 0;
  top: 0;

  svg {
    width: 50px;
  }

  ${copy.XS} {
    color: ${colors.PRIMARY_GREY_000};
  }
`

export const AvatarImage = styled.img``
